import React from "react";
import HomePageExplainer from "./Contents/HomePageExplainer";
import TasksExplainer from "./Contents/TasksExplainer";
import PolicyLandscapingExplainer from "./Contents/PolicyLandscapingExplainer";
import BenchmarkingExplainer from "./Contents/BenchmarkingExplainer";
import ETrackerPolicyProgressExplainer from "./Contents/ETrackerPolicyProgressExplainer";
import ETrackerStageInsightsExplainer from "./Contents/ETrackerStageInsightsExplainer";
import PolicyDirectoryExplainer from "./Contents/PolicyDirectoryExplainer";
import PolicyPartnerExplainer from "./Contents/PolicyPartnerExplainer";
import PolicyUpdatesAndCountryEventsExplainer from "./Contents/PolicyUpdatesAndCountryEventsExplainer";
import FAQsExplainer from "./Contents/FAQsExplainer";
import SystemsManagementExplainer from "./Contents/SystemsManagementExplainer";
import TrackingAndAssessmentExplainer from "./Contents/TrackingAndAssessmentExplainer";
import UserManagementExplainer from "./Contents/UserManagementExplainer";
import UserOrganizationExplainer from "./Contents/UserOrganizationExplainer";
import AuditTrailExplainer from "./Contents/AuditTrailExplainer";
import PolicyLifecycleManagementExplainer from "./Contents/PolicyLifecycleManagementExplainer"
import ProfileInformationExplainer from "./Contents/ProfileInformationExplainer"
import UserInformationExplainer from "./Contents/UserInformationExplainer"

const explainerComponents = {
  HomePageExplainer,
  TasksExplainer,
  PolicyLandscapingExplainer,
  BenchmarkingExplainer,
  ETrackerPolicyProgressExplainer,
  ETrackerStageInsightsExplainer,
  PolicyLifecycleManagementExplainer,
  PolicyDirectoryExplainer,
  PolicyPartnerExplainer,
  PolicyUpdatesAndCountryEventsExplainer,
  FAQsExplainer,
  SystemsManagementExplainer,
  TrackingAndAssessmentExplainer,
  UserManagementExplainer,
  UserOrganizationExplainer,
  AuditTrailExplainer,
  ProfileInformationExplainer,
  UserInformationExplainer,
};

const Explainer = ({ type, ...props }) => {
  const Component = explainerComponents[type];

  return Component ? <Component {...props} /> : null;
};

export default Explainer;
